import type { NuxtError } from '#app'
import { useQuery } from '@tanstack/vue-query'
import type { Company, Order } from '~/types/company'

export const useStoreCompany = defineStore('company', () => {
  const company = ref<Company | null>(null)

  const { langCode } = storeToRefs(useStoreStore())

  const fetchCompany = async () => {
    try {
      await useNuxtApp().$queryClient.fetchQuery({
        queryKey: ['fetchCompany', langCode.value],
        queryFn: async () => {
          const data: Company = await useNuxtApp().$api(`/api/customers/companies/`)
          company.value = data
          return data
        }
      })
    } catch (error) {
      const { statusCode } = error as NuxtError
      showError({ statusCode })
    }
  }

  const getOrders = () => {
    return useQuery({
      queryKey: ['fetchOrders'],
      queryFn: async () => {
        return (await useNuxtApp().$api(`/api/customers/loyalty/orders/`)) as Order[]
      },
      staleTime: 1800000 // 30 minutes
    })
  }

  return { company, fetchCompany, getOrders }
})
